import {Network} from "../../fstn/network";
import { Box, Card } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import React, {useEffect, useState} from "react";
import {Cursor} from "../../fstn/cursor";
import {State} from "./State";
import {ActionFactory} from "../../fstn/actionFactory";

const useStyles = makeStyles(theme => ({
    container: {
        margin: theme.spacing(0, 4, 4, 4)
    },
    content: {
        display: 'flex',
        flexDirection: "row",
        height: 120,
        margin: theme.spacing(1),
        overflowX: "scroll",
        '&::-webkit-scrollbar': {
            height: '0.4em'
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,.1)',
            borderRadius: '0.4em'
        }
    }
}));

interface Props {
    factory: ActionFactory
    network: Network
}
export function TimeLine({factory, network}: Props) {
    const classes = useStyles();
    const [choices, setChoices] = useState({});
    const [states, setStates] = useState<React.ReactElement[]>([]);

    useEffect(() => {
        const buildStates = (network: Network, choices: {[key: string]: string}) => {
            const script: React.ReactElement[] = [];

            if (! network) return script;

            const cursor = new Cursor(network, factory);
            const handleChoice = (state: string, choice: string) => {
                setChoices(choices => ({...choices, [state]: choice}));
            };
            const visited: string[] = [];

            while (! visited.includes(cursor.state)) {
                const state = cursor.state;
                const triggers = cursor.triggers;
                let trigger = 'continue';

                visited.push(state);
                if (triggers.length > 1) {
                    trigger = choices[state] || triggers[0];
                    choices[state] = trigger;
                }
                script.push(<State
                    key={state} choice={choices[state]} name={cursor.name} triggers={cursor.triggers} state={state}
                    onChoice={handleChoice}/>);
                cursor.trigger(trigger);
            }
            return script;
        };

        setStates(buildStates(network, choices));
    }, [choices, factory, network]);
    return (
        <Card className={classes.container}>
            <Box className={classes.content}>
                {states}
            </Box>
        </Card>
    );
}